import * as React from 'react'

import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { SafeHtml } from '@thg-commerce/gravity-elements'

import { Gallery } from './Gallery/Gallery'
import { GalleryItem } from './Gallery/GalleryThumbnail'

export interface ItemCountupProps {
  items: {
    images: GalleryItem[]
    title: string
    content: string
  }[]
  isAmp: boolean
}

const StyledGridItem = styled(GridItem)``

const StyledGrid = styled(Grid)`
  margin: 0;

  ${StyledGridItem}:not(:last-child):not(:nth-last-child(2)) {
    margin-bottom: ${spacing(9)};
  }
`

const ItemNumber = styled.span`
  ${Text('large2', 'alternate')}
`

const ItemTitle = styled.h3`
  ${Text('medium1', 'alternate')}
  margin: ${spacing(2)} 0;
`

const ItemContent = styled(SafeHtml)`
  ${Text('bodyText', 'default')}
`

export const ItemCountup = React.memo((props: ItemCountupProps) => {
  const ItemCountupItems = props.items.map((item, index) => {
    return (
      <React.Fragment key={index}>
        <StyledGridItem
          colSpan={[12, 12, 6, 4]}
          colStart={1}
          rowStart={index * 2 + 1}
        >
          <Gallery items={item.images} isAmp={props.isAmp} />
        </StyledGridItem>
        <StyledGridItem
          colSpan={[12, 12, 6, 8]}
          colStart={[1, 1, 7, 5]}
          rowStart={[
            index * 2 + 2,
            index * 2 + 2,
            index * 2 + 1,
            index * 2 + 1,
          ]}
        >
          <ItemNumber>{index + 1}.</ItemNumber>
          <ItemTitle>{item.title}</ItemTitle>
          <ItemContent
            __dangerouslyAllowedTags={['span', 'strong', 'em']}
            content={item.content}
          />
        </StyledGridItem>
      </React.Fragment>
    )
  })

  return <StyledGrid>{ItemCountupItems}</StyledGrid>
})
